/**
 * JSON serialization support for ObjectFit
 */

import { z } from 'zod';
import { ObjectFit } from './ObjectFit';

/**
 * Zod schema for ObjectFit
 */
export const ObjectFitSchema = z.nativeEnum(ObjectFit);

/**
 * Convert ObjectFit to JSON
 */
export function objectFitToJSON(objectFit: ObjectFit): unknown {
  return objectFit;
}
